var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiversity = function SvgDiversity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "diversity_svg__svg-icon"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#diversity_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.008 8.123a1.291 1.291 0 1 0 0-2.583 1.291 1.291 0 0 0 0 2.583ZM15.064 11.486h-6.11a3.054 3.054 0 0 1 6.108 0h.002ZM10.144 14.972h-6.11a3.054 3.054 0 0 1 6.108 0h.002ZM7.085 8.996l-1.322 1.322 1.322 1.322 1.322-1.322-1.322-1.322ZM19.966 14.972h-6.11a3.054 3.054 0 0 1 6.108 0h.002ZM17.585 9.173h-1.323l-.66 1.146.66 1.145h1.323l.661-1.145-.661-1.146ZM15.064 18.46h-6.11a3.054 3.054 0 0 1 6.108 0h.002ZM10.666 14.965l1.357-2.324 1.33 2.327-2.687-.003Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "diversity_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
};
export { SvgDiversity as ReactComponent };